<!-- 公共标题 -->
<template>
  <div class="page-title" ref="title">
    <p
      class="title"
      v-html="title"
      :style="{ '--titleColor': titleColor}"
    ></p>
    <p
      class="tit"
      :style="{ '--titCorol': titColor }"
      v-if="tit !== ''"
      v-html="tit"
    ></p>
    <div v-if="tip && tip.length>0" class="tip" :style="{'right':tipRight}">
      <div class="tip-item" v-for="(item,index) in tip" :key="index">
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      value: {
        type: String,
        default: "",
      },
    },
    tit: {
      value: {
        type: String,
        default: "",
      },
    },
    titleColor: {
      value: {
        type: String,
        default: "",
      },
    },
    titColor: {
      value: {
        type: String,
        default: "",
      },
    },
    tipRight: {
      value: {
        type: String,
        default: "",
      },
    },
    tip:{
      value: {
        type: Array,
        default: [],
      },
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.handleScroll();
    });
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      const domScorllTop = document.getElementsByClassName("page-title");
      let windowH =
        document.documentElement.clientHeight || document.body.clientHeight;
      Array.prototype.forEach.call(domScorllTop, function (e, index) {
        if (e.getBoundingClientRect().top <= windowH - 50) {
          e.className = "page-title top-enter";
        } else {
          e.className = "page-title top-leave";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tip{
  position: absolute;
  right:0;
  top:-5px;
  display: flex;
  align-content: center;
  justify-content: flex-start;
   opacity: 0;
    transition: opacity 1s, transform 1s, -webkit-transform 1s;
    transform: translateY(50px);
  .tip-item{
   margin-right: -10px;
    background: url('../../assets/common/tip.png') center center no-repeat;
    background-size:100% 100%;
    width: 132px;
    height: 93px;
    font-family: PingFang-SC-Bold;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #ffffff;
    box-sizing: border-box;
    padding-top: 13px;
    text-align: center;
  }
}
.page-title {
  position:relative;
  width: 1200px;
  margin: 0 auto;
  p {
    opacity: 0;
    transition: opacity 1s, transform 1s, -webkit-transform 1s;
    transform: translateY(50px);
    text-align: center;
    color: var(--titleColor);
    
  }

  .title {
    // height: 50px;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;

    line-height: 50px;
  }

  .tit {
    margin-top: 16px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--titCorol);
    transition: opacity 1.8s, transform 1.8s, -webkit-transform 1.8s;
    line-height: 24px;
  }
}

.top-enter {
  p,.tip{
    opacity: 1;
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
 
}

.top-leave {
  p,.tip {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
}
</style>
